export const BrowseAndBookProfile = {
  ProfileCard: 'profile-card',
  BookNowButton: 'book-now-button',
};
